import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Instagram, Linkedin, Facebook } from "lucide-react";

export default function Footer() {
  const [site, setSite] = useState({});
  useEffect(() => {
    api.get("/site/content").then((r) => setSite(r.data || {})).catch(() => {});
  }, []);

  return (
    <footer data-testid="public-footer" className="bg-ink text-white/90 relative">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-heading text-3xl lg:text-4xl leading-tight tracking-tight">
            From concept to construction.
            <br />
            <span className="text-white/50">Let's build something considered.</span>
          </div>
          <Link
            to="/contact"
            data-testid="footer-contact-btn"
            className="mt-8 inline-block border border-white/40 text-white px-6 py-3 text-sm hover:bg-white hover:text-ink transition-colors"
          >
            Get in touch →
          </Link>
        </div>

        <div className="md:col-span-2 md:col-start-7">
          <div className="eyebrow text-white/50 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white text-white/80">Home</Link></li>
            <li><Link to="/projects" className="hover:text-white text-white/80">Projects</Link></li>
            <li><Link to="/team" className="hover:text-white text-white/80">Team</Link></li>
            <li><Link to="/contact" className="hover:text-white text-white/80">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-white/50 mb-4">Studio</div>
          <ul className="space-y-2 text-sm text-white/80">
            {site.office_address && <li data-testid="footer-address">{site.office_address}</li>}
            {site.contact_phone && <li data-testid="footer-phone">{site.contact_phone}</li>}
            {site.contact_email && (
              <li>
                <a href={`mailto:${site.contact_email}`} className="hover:text-white" data-testid="footer-email">{site.contact_email}</a>
              </li>
            )}
            {site.business_hours && <li className="text-white/50 mt-2 font-mono text-xs" data-testid="footer-hours">{site.business_hours}</li>}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow text-white/50 mb-4">Follow</div>
          <div className="flex gap-4">
            {site.social_instagram && <a href={site.social_instagram} target="_blank" rel="noreferrer" className="hover:text-white text-white/70"><Instagram size={18} /></a>}
            {site.social_linkedin && <a href={site.social_linkedin} target="_blank" rel="noreferrer" className="hover:text-white text-white/70"><Linkedin size={18} /></a>}
            {site.social_facebook && <a href={site.social_facebook} target="_blank" rel="noreferrer" className="hover:text-white text-white/70"><Facebook size={18} /></a>}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50 font-mono">
          <div>© {new Date().getFullYear()} AS Design Studios. All rights reserved.</div>
          <Link
            to="/staff/login"
            data-testid="footer-staff-link"
            className="hover:text-white transition-colors tracking-widest uppercase"
          >
            Staff
          </Link>
        </div>
      </div>
    </footer>
  );
}
